// @flow
import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from './backendContentCountTab.css';


type BackendContentCountTabPropTypes = {
  count?: number,
  to: string,
  title: string,
  isActive?: Function,
};

const BackendContentCountTab = ({
  count = 0,
  title,
  to,
  isActive,
}: BackendContentCountTabPropTypes) => (
  <NavLink
    to={to}
    className={styles.backendContentCountTab}
    activeClassName={styles.active}
    isActive={isActive}
  >
    { title }
    (
    { count }
    )
  </NavLink>
);


export default BackendContentCountTab;



// WEBPACK FOOTER //
// ./src/scripts/components/BackendContentCountTab/index.jsx